import { render, staticRenderFns } from "./nav-sidebar.vue?vue&type=template&id=3741bf2d&scoped=true&"
import script from "./nav-sidebar.vue?vue&type=script&lang=js&"
export * from "./nav-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./nav-sidebar.vue?vue&type=style&index=0&id=3741bf2d&lang=scss&scoped=true&"
import style1 from "./nav-sidebar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3741bf2d",
  null
  
)

export default component.exports